<template>
  <teleport to="body">
    <WdsModal
      :show="open"
      custom-size="550px"
      no-close-icon
      @cancel="emit('close')"
    >
      <WdsStack direction-column gap-xs>
        <WdsText xl primary>
          {{ $t('Do you want to decline the contract?') }}
        </WdsText>
        <WdsText tertiary>
          {{
            $t(
              "If you decline the contract, the hire for this job will not be finalised.",
            )
          }}
        </WdsText>
      </WdsStack>

      <template #footer>
        <WdsStack justify-end gap-sm>
          <WdsButton :disabled="rejectHireLoading" @click="emit('close')">{{ $t('Cancel') }}</WdsButton>

          <WdsButton error :disabled="rejectHireLoading" @click="declineContract">{{ $t('Decline contract') }}</WdsButton>
        </WdsStack>
      </template>
    </WdsModal>
  </teleport>
</template>

<script setup lang="ts">
import { useMutation } from '@vue/apollo-composable'
import { WdsButton, WdsModal, WdsStack, WdsText } from '@worksome/wds-components';

import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import NetworkError from '@/utils/notification/NetworkError'
import { RejectHireMutation } from '@/components/Hire/graphql/mutations'

const props = withDefaults(
  defineProps<{
  open?: boolean
  hireId: string
  recruiterId: string
  }>(),
  {
    open: false,
  }
)

const emit = defineEmits(['close', 'hire-canceled'])

const {
  loading: rejectHireLoading,
  mutate: mutateRejectHire,
} = useMutation(RejectHireMutation, {
  clientId: 'publicApi',
})

const declineContract = async () => {
  try {
    await mutateRejectHire({
      input: {
        account: props.recruiterId,
        hire: props.hireId,
      }
    })

    emit('hire-canceled')
    emit('close')
  } catch (ex: any) {
    new NetworkError({
      ex,
      msg: $t('An error occurred'),
    }).dispatch()
  }
}
</script>

<style scoped lang="scss">
:deep(.wds-modal-header) {
  @apply tw-p-0;
}
</style>
